export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20natural%20light%20photography%20of%20modern%20minimalist%20fashion%20accessories%20and%20clothing%20items%20arranged%20on%20a%20light%20cream%20textured%20surface%2C%20clean%20aesthetic%20composition%20with%20generous%20negative%20space%2C%20warm%20neutral%20tones%20of%20beige%20cream%20and%20soft%20olive%2C%20editorial%20product%20photography%20style%2C%20high%20detail%2C%20Scandinavian%20design%20influence%2C%20elegant%20simplicity%20with%20organic%20textures%20and%20subtle%20natural%20shadows%2C%20bright%20airy%20atmosphere&width=1600&height=900&seq=hero-bg-yoybuy-01&orientation=landscape"
          alt="YOYBUY Spreadsheet — модные товары из Китая"
          title="YOYBUY Spreadsheet товары"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          YOYBUY Spreadsheet — Умная система покупок из Китая через таблицы
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Покупайте товары из Taobao, 1688 и Китая через удобную spreadsheet-систему.
          Сравнивайте цены, комиссии и доставку в одном месте.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить доступ к YOYBUY Spreadsheet
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </a>
          <a
            href="#categories"
            className="px-8 py-3.5 rounded-full border-2 border-white/70 text-white text-base font-semibold hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Смотреть категории
            <i className="ri-arrow-down-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}